/*
 * Author: Danny Ehlers
 * Date: 8/16/2018
 * Custom spinner based of angular-epic-spinners.
 */
import { Component, OnInit, Input } from '@angular/core';
import { CapSpinnerService } from './services/cap-spinner.service';

@Component({
  selector: 'app-cap-spinner',
  templateUrl: './cap-spinner.component.html',
  styleUrls: ['./cap-spinner.component.scss']
})
export class CapSpinnerComponent {

  @Input() animationDuration;
  @Input() size;
  @Input() color;

  constructor(public capSpinnerService: CapSpinnerService) {  }


}
